import { useEffect } from 'react';

const BASE_TITLE = 'Readable';

/**
 * WCAG 2.4.2 — Actualiza document.title al montar la página.
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
